import { render, staticRenderFns } from "./GuiaPrecios.vue?vue&type=template&id=09afdc64&scoped=true&"
import script from "./GuiaPrecios.vue?vue&type=script&lang=js&"
export * from "./GuiaPrecios.vue?vue&type=script&lang=js&"
import style0 from "./GuiaPrecios.vue?vue&type=style&index=0&id=09afdc64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09afdc64",
  null
  
)

export default component.exports